// src/lib/useCollectionBounds.js
//
// The collection price bounds + the creator's default price (room-commerce
// `bounds` for collection_unlock: min / max cents, creator_default_cents,
// 012-01), fetched while `active` (a modal or sheet is open). Until the server
// answers — or when it can't — the FALLBACK_BOUNDS apply; the server enforces
// the real bounds on create either way. Extracted from Studio's
// CollectionModal (031-01; removed with that page in 031-03) so the profile's post composer prefills the same
// default.

import { useEffect, useState } from 'react';
import { useSiweAuth } from '../context/AuthContext';
import { itemBounds } from './roomCommerce';

export const FALLBACK_BOUNDS = { min_cents: 100, max_cents: 20000, default_cents: 1000 };
export const DEFAULT_COLLECTION_USD = '10';
export const centsToDollars = (c) => (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2));

/** { bounds, creatorDefaultCents } — creatorDefaultCents is null until a positive default answers. */
export function useCollectionBounds(active) {
  const { authToken } = useSiweAuth();
  const [bounds, setBounds] = useState(FALLBACK_BOUNDS);
  const [creatorDefaultCents, setCreatorDefaultCents] = useState(null);

  useEffect(() => {
    if (!active || !authToken) return undefined;
    let cancelled = false;
    itemBounds(authToken, 'collection_unlock')
      .then((b) => {
        if (cancelled || !b?.min_cents || !b?.max_cents) return;
        setBounds(b);
        setCreatorDefaultCents(b.creator_default_cents > 0 ? b.creator_default_cents : null);
      })
      .catch(() => { /* keep the fallback; the server still enforces */ });
    return () => { cancelled = true; };
  }, [active, authToken]);

  return { bounds, creatorDefaultCents };
}

export default useCollectionBounds;
